/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: undefined,
  },
  mutations: {
    setUserInfo(s, user) {
      s.user = user;
    },
  },
  actions: {
  },
  modules: {
  },
  getters: {
    userDisplayName: (s) => {
      if (s.user?.family_name && s.user?.given_name) {
        return `${s.user.family_name}${s.user.given_name}`;
      }
      return '使用者姓名';
    },
    isLogin: (s) => s.user !== undefined,
    user: (s) => s.user,
    userID: (s) => s.user?.id,
    isAdmin: (s) => s?.user?.role === 'admin',
    isAdvStaff: (s) => s?.user?.role === 'advstaff',
    isDispatcher: (s) => s?.user?.role === 'dispatcher',
    isAccounting: (s) => s?.user?.role === 'accounting',
    // 預約操作（新增過去日期、編輯／取消過去的預約、切換支付狀態）不受時間限制的角色：
    // 管理者、派案人員、帳務人員（個管與進階個管仍受限）
    isUnlimitedAppointmentRole: (s) => ['admin', 'dispatcher', 'accounting'].includes(s?.user?.role),
    // 超級管理員：可使用 debug 頁面的檢視視角功能（後端 Staff.super_admin）
    isSuperAdmin: (s) => s?.user?.super_admin === true,
    // 正在以「檢視視角」使用其他帳號時，為原本帳號的 { id, name }；否則為 null/undefined
    impersonatedBy: (s) => s?.user?.impersonated_by || undefined,
  },
});
